var map = {
	"./": 1379,
	"./Clutch": 2727,
	"./Clutch.js": 2727,
	"./NewUi": 2728,
	"./NewUi.js": 2728,
	"./OldUi": 2729,
	"./OldUi.js": 2729,
	"./index": 1379,
	"./index.js": 1379,
	"./style": 872,
	"./style.js": 872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4279;